import React from 'react'

import LandingGlobalHeader from './landing/LandingGlobalHeader'
import useLandingAuth from './landing/useLandingAuth'

function Header2() {
  const { loadingUser, userInfo, openModal, logoutHandler, authModals } = useLandingAuth()

  return (
    <>
      <LandingGlobalHeader
        loadingUser={loadingUser}
        userInfo={userInfo}
        onOpenModal={openModal}
        onLogout={logoutHandler}
        compactActions
      />
      {authModals}
    </>
  )
}

export default Header2
